import { render, staticRenderFns } from "./LeaderBoardBlock.vue?vue&type=template&id=4603d662&scoped=true&"
import script from "./LeaderBoardBlock.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardBlock.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBoardBlock.vue?vue&type=style&index=0&id=4603d662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603d662",
  null
  
)

export default component.exports